import type { HelpFile } from '../../types/help'
import { FieldPropertiesTestIds } from '../../../testids/FieldPropertiesTestIds'

export const fieldPropertiesHelp: HelpFile = {
  docPage: '/docs/admin/form-layouts',
  texts: {
    [FieldPropertiesTestIds.fieldLabelInput]:
      'Label shown above the field in the rendered form — leave empty to use the attribute definition label.',
    [FieldPropertiesTestIds.fieldPlaceholderInput]:
      'Placeholder text shown inside the empty input as a hint.',
    [FieldPropertiesTestIds.fieldDefaultInput]:
      'Default value pre-filled when a new record is created — leave empty for no default.',
    [FieldPropertiesTestIds.fieldTemplateInput]:
      'Optional template expression evaluated to compute the field value (for example concatenating other fields).',
    [FieldPropertiesTestIds.colSpanCustomBtn]:
      'Switch the column-span control into custom mode to enter an arbitrary integer.',
    [FieldPropertiesTestIds.colSpanCustomInput]:
      'Custom column-span value (1–12) for this field — overrides the preset buttons.',
    [FieldPropertiesTestIds.visibilityFieldKeySelect]:
      'Pick the field whose value drives the visibility condition for the current field.',
  },
}
